import { useMutation, useQueryClient } from "@tanstack/react-query";

import { toast } from "react-toastify";

import { saveCustomNotification } from "../../services/custom_notifications";

import { ISaveCustomNotification } from "../../types/custom_notifications";

interface IPayload {
    data: ISaveCustomNotification;
    setIsProcessing: React.Dispatch<React.SetStateAction<boolean>>;
    setApiError: React.Dispatch<React.SetStateAction<string | null>>;
};

const useSaveCustomNotification = () => {
    const queryClient = useQueryClient();

    const mutationFn = async (payload: IPayload) => {
        return await saveCustomNotification(payload.data);
    };

    return useMutation({
        mutationFn,
        onMutate: (variables: IPayload) => {
            variables.setIsProcessing(true);
            variables.setApiError(null);
        },
        onSuccess: (status: number, variables: IPayload) => {
            if (status === 200) {
                queryClient.invalidateQueries({ queryKey: ["custom_notifications"] });
                toast.success("Custom Notification saved successfully!");
            }
            variables.setIsProcessing(false);
            variables.setApiError(null);
        },
        onError: (error: any, variables: IPayload) => {
            variables.setIsProcessing(false);
            variables.setApiError(error.response?.data?.message);
            toast.error(error.response?.data?.message);
        },
        onSettled: (status: number | undefined, error: any, variables: IPayload) => {
            if (status === 200) {
                variables.setIsProcessing(false);
                variables.setApiError(null);
            }
        }
    });
};
export default useSaveCustomNotification;